var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Form from "react-bootstrap/Form";
import iconArrowRight from "../assets/icons/Arrow/Right.svg";
import iconArrowSimpleLightDown from "../assets/icons/Arrow Simple Light/Down.svg";
import { styleBlock } from "../styleBlock";
const SupplyPointNav = (_a) => {
    var { className, value, rootTitle, rootHref, rootOnClick, selectSupplyPointLabel, currentTitle, currentPath, supplyPoints, supplyPointIcon, supplyPointLabel, supplyPointsOnChange, supplyPointIconAlt } = _a, props = __rest(_a, ["className", "value", "rootTitle", "rootHref", "rootOnClick", "selectSupplyPointLabel", "currentTitle", "currentPath", "supplyPoints", "supplyPointIcon", "supplyPointLabel", "supplyPointsOnChange", "supplyPointIconAlt"]);
    const classNames = styleBlock("supplypointnav");
    const arrowIcon = React.createElement("img", { width: 15, src: iconArrowRight, className: classNames("arrow"), role: "presentation" });
    return (React.createElement("div", { className: classNames.toString() },
        rootTitle && (React.createElement("a", { href: rootHref, onClick: rootOnClick, className: classNames("rootTitle") },
            React.createElement("span", { className: classNames("rootTitle", "label") }, rootTitle),
            arrowIcon)),
        React.createElement("div", { className: classNames("fakeselect") }, supplyPoints && supplyPoints.length ? (React.createElement(React.Fragment, null,
            React.createElement("img", { className: classNames("fakeselect", "icon"), src: supplyPointIcon, alt: supplyPointIconAlt, width: 24, height: 24 }),
            React.createElement("span", { className: classNames("fakeselect", "title") }, supplyPointLabel),
            React.createElement("span", { id: "supplypointnav-supply-point-select-label", className: classNames("fakeselect", "label") }, selectSupplyPointLabel),
            React.createElement("img", { className: classNames("fakeselect", "arrow"), src: iconArrowSimpleLightDown, width: 14, role: "presentation" }),
            React.createElement(Form.Control, { "aria-labelledby": "supplypointnav-supply-point-select-label", as: "select", onChange: supplyPointsOnChange, defaultValue: value }, supplyPoints.map((sp, idx) => (React.createElement("option", { value: sp.id, key: "supplypointnav-" + idx }, sp.title)))))) : (React.createElement("span", { className: classNames("fakeselect", "label d-inline") }, supplyPointLabel))),
        currentPath &&
            currentPath.map((path, index) => {
                if (index < currentPath.length - 1) {
                    return (React.createElement("a", { href: path.href, onClick: path.onClick, className: classNames("currentTitle"), key: "supCurPath-" + path.id },
                        arrowIcon,
                        path.title));
                }
                else {
                    return (React.createElement("span", { className: classNames("currentTitle"), key: "supCurPath-" + path.id },
                        arrowIcon,
                        path.title));
                }
            }),
        currentTitle && !currentPath && (React.createElement("span", { className: classNames("currentTitle") },
            arrowIcon,
            currentTitle))));
};
export default SupplyPointNav;
//# sourceMappingURL=index.js.map